import GraphicForKunji from "../assets/images/GraphicForKunji.png";
import brain from "../assets/images/brain.png";

const LC3 = () => {
  return (
    <section className="w-full max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* First Row */}
      <div className="mt-16 sm:mt-24 lg:mt-36 xl:mt-48 flex flex-col lg:flex-row items-center gap-8 lg:gap-24">
        {/* Text Section */}
        <div className="order-2 lg:order-1 flex-1 text-center lg:text-left">
          <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold mb-6 lg:mb-10">
            Supercharge Student Performance
          </h2>
          <ul className="list-disc pl-6 space-y-3 lg:space-y-4">
            <li className="text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl font-semibold">
              Smart quizzes with real-time analytics
            </li>
            <li className="text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl font-semibold">
              Personalized practice sets for every student
            </li>
            <li className="text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl font-semibold">
              Integration with LMS and smart classroom platforms
            </li>
          </ul>
        </div>

        {/* Graphic */}
        <div className="order-1 lg:order-2 flex-1 flex justify-center">
          <img
            src={GraphicForKunji}
            alt="Graphic for Kunji"
            className="w-full max-w-sm sm:max-w-md lg:max-w-lg xl:max-w-2xl h-auto object-contain"
          />
        </div>
      </div>

      {/* Second Row */}
      <div className="flex flex-col-reverse lg:flex-row items-center justify-between gap-8 mt-16 sm:mt-24 lg:mt-32 xl:mt-40 mb-8">
        <div className="flex-1 flex justify-center lg:justify-start">
          <img
            src={brain}
            alt="Brain Graphic"
            className="w-full max-w-xs sm:max-w-sm lg:max-w-md h-auto object-contain"
          />
        </div>

        <div className="flex-1 text-center lg:text-right">
          <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl font-bold mb-6 lg:mb-8">
            Why It Matters?
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl leading-relaxed font-semibold text-gray-700">
            Inspire curiosity, boost academic outcomes, and make every lesson
            highly interactive. Whether it’s helping a 2nd grader understand
            basic math or guiding a 10th grader through complex grammar, let
            AI do the heavy lifting—so you can learn comfortably, confidently,
            and smartly. Embrace Kunji, the AI-powered learning revolution—
            because you deserve more than just textbooks.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LC3;
